export default function transformResponse(data) {
  if (!data) {
    return {};
  }
  return data.pipelines_by_pk;
}
